import { useEffect, useState } from 'react';
import SearchIcon from "../../../assets/images/icons/search.svg";
import * as actions from '../../../redux/actions/growthEngine';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector, useDispatch } from "react-redux";
import Error from '../../../helper/Error'
import MusicLoader from '../../../helper/MusicLoader';
import useDebounce from '../../../helper/useDebounce';
const tabs = ['Videos', 'Shorts'];

export const YoutubeVideos = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const dispatch = useDispatch();
  const { formData } = useSelector(state => state.growthEngine);
  const { selectedChannel, channelVideoShortsList } = formData;
  const videoList = formData.youtubeVideoList;
  const selectedYoutubeVideo = formData.selectedYoutubeVideo;


  useEffect(() => {
    // Load default (Videos) on mount
    dispatch(actions.getYoutubeVideosList(selectedChannel, toast, setIsLoading));
  }, [dispatch, selectedChannel]);

  useEffect(() => {
    if (selectedYoutubeVideo?.videoId) {
      setSelectedVideoId(selectedYoutubeVideo.videoId);
    }
  }, [selectedYoutubeVideo]);

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    // debounce(query)
  };

  const handleSearch = () => {
    if (!searchQuery.trim()) return;
  //Check if query is a valid YouTube video/short URL
  const youtubeRegex =
    /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|shorts\/)|youtu\.be\/)[a-zA-Z0-9_-]{11}/;

  if (!youtubeRegex.test(searchQuery)) {
    toast.warning("Please enter a valid YouTube video or Shorts URL", {
      position: "top-center",
      theme: "colored",
      hideProgressBar: true,
    });
    return;
  }

  dispatch(actions.searchYoutubeVideoAndShorts(searchQuery, toast, setSearchLoading));
  setSearchQuery("");
};


  const formatDateToMMDDYYYY = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return ''; // Invalid date handling

    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();

    return `${mm}/${dd}/${yyyy}`;
  };

  const handleVideoSelection = (value) => {
    const isAlreadySelected = formData.selectedYoutubeVideo?.videoId === value.videoId;
    if (isAlreadySelected) {
      // Deselect the video
      dispatch(actions.updateFormData({ selectedYoutubeVideo: {} }));
      setSelectedVideoId('');
    } else {
      // Select the new video
      dispatch(actions.updateFormData({ selectedYoutubeVideo: value }));
      setSelectedVideoId(value.videoId);
    }
  };

  
  return (
    <div className="ChooseYoutubeVideo-page bg-theme_clr1 font-inter py-5">
      <ToastContainer />
      <div className="container max-w-[875px]">
        <section>
          <div className="heading text-white font-medium text-center mb-[28.5px]">
            <h5 className="text-[22.5px] mb-2">Choose your Video</h5>
            <div className="description text-white text-opacity-80 text-[15px]">Choose the YouTube Video or Short you want to promote.</div>
          </div>

          <div className="info-box bg-white rounded-xl overflow-auto">
            <div className="wrapper border-b p-4 lg:p-5">
              <div className="text-[18px] font-bold">Select the video you want to promote.</div>
              <span className="text-xs text-slate-700">Make sure it's a video URL not a channel URL</span>
            </div>
            <div className="content-wrapper p-4">
              <div className="search-box relative">
                <span className="icon absolute start-[16px] top-1/2 transform -translate-y-1/2 z-1">
                  <img src={SearchIcon} alt="Search Icon" className="block opacity-60" />
                </span>

                <input
                  type="search"
                  className="h-[45px] w-full bg-white border border-slate-300 text-base text-black placeholder:text-gray-400 focus:outline-none rounded-md ps-[45px] pe-[75px] py-2"
                  placeholder="Enter your YouTube video URL or select a video from your channel."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  disabled={searchLoading}
                />

                {searchLoading ? (
                  // Music loader placeholder (replace with your actual loader component or gif)
                  <span className="absolute top-1/2 -translate-y-1/2 end-4">
                    <MusicLoader />
                    {/* <img
                      src="/assets/loader-music.gif"
                      alt="Loading"
                      className="w-[60px] h-[45px] object-contain"
                    /> */}
                  </span>
                ) : (
                  <span
                    className="text-theme_clr4 absolute top-1/2 -translate-y-1/2 end-4 cursor-pointer"
                    onClick={() => handleSearch()}
                  >
                    Search
                  </span>
                )}
              </div>
            </div>

            <div className="content-wrapper">
              {/* Tabs Menu Section */}
              <div className="tabs-wrapper">
                {/* Tabs Menu */}
                {/* <div className="flex border-b-2 border-slate-300">
                  {tabs.map((tab) => (
                    <button key={tab}
                      onClick={() => handleTabClick(tab)}
                      className={`font-semibold border-b-2 border-slate-300 mb-[-2px] px-4 py-2 ${activeTab === tab ? 'border-theme_clr2 text-theme_clr2' : 'text-gray-500 hover:text-blue-500'}`}
                    >
                      {tab}
                    </button>
                  ))}
                </div> */}

                {/* Tab Content */}
                <div className="max-h-[400px] divide-y divide-gray-200 overflow-auto">

                  {
                    isLoading ?
                      <MusicLoader />
                      :
                      videoList && videoList.length > 0 ? videoList.map((info, index) => {
                        const isSelected = selectedVideoId === info.videoId;

                        return (
                          <div className="video-card" key={index}>
                            <div
                              onClick={() => handleVideoSelection({
                                videoId: info.videoId,
                                title: info.title,
                                // type: info.type,
                                videoUrl: info.videoUrl,
                                channelName: info.channelName,
                                channelId: info.channelId,
                                thumbnail: info?.thumbnail,
                                releaseDate: info?.publishedAt,
                              })}
                              className={`video-card cursor-pointer flex p-4 space-x-3 pe-10 relative 
                                       ${isSelected ? 'bg-green-100 border-2 border-green-500' : 'bg-white'} 
                                              rounded-md transition-colors duration-150`}
                            >
                              <img src={info?.thumbnail} alt="Video thumbnail" className="w-[80px] h-[60px] rounded-md object-cover mt-[3px]" />
                              <div className="info-wrapper flex-1">
                                <div className="text-[16px] font-bold">{info.title}</div>
                                <div className="text-sm flex items-center gap-1 mb-[2px]">
                                  <img src={require('../../../assets/images/admin/Youtube.png')} alt="Youtube" style={{ width: '25px' }} />
                                  Channel: {info.channelName}
                                </div>
                                <div className="text-xs">Release Date: {info?.publishedAt ? formatDateToMMDDYYYY(info.publishedAt) : 'N/A'}</div>
                              </div>
                            </div>
                          </div>
                        );
                      }) : <div className="text-center text-gray-500 py-4">No video or shorts found</div>
                  }
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}
